/**
 * Identity for in-app ads, shared by every surface that runs them.
 *
 * Each ad's dismissal is one flat, top-level `seen_nux_json` key: the server
 * merges seen_nux at the top level ONLY, so nesting siblings under a single
 * object lets an unrelated partial POST clobber them. Ids are year-versioned so
 * a later campaign in the same slot shows again for teachers who dismissed the
 * previous one.
 *
 * ─── Every surface owns its keys; none are shared ──────────────────────────
 * A campaign that runs in three slots takes three ids, so it is dismissed three
 * times. That is deliberate, and it should not be "tidied" into one key.
 */
export const AD_IDS = {
  DONUTS: 'donuts_2026',
  CURRICULUM_ANNOUNCEMENT: 'curriculum_announcement_2026',
  PREMIUM_EXPIRING: 'premium_expiring_2026',
  PREMIUM_ENDED: 'premium_ended_2026',
  PREMIUM_ENDED_INVITE: 'premium_ended_invite_2026',
  TRIAL_EXPIRING: 'trial_expiring_2026',
  TRIAL_EXPIRING_INVITE: 'trial_expiring_invite_2026',
  TRIAL_ENDED: 'trial_ended_2026',
  TRIAL_ENDED_INVITE: 'trial_ended_invite_2026',
  MATH_CHALLENGE: 'math_challenge_2026',
  MATH_FREE_YEAR: 'math_free_year_2026',
  REFERRAL: 'referral_2026',
};

// The post-export slot. Every id is `export_`-prefixed because this surface
// shares no dismissal with any other — see the exception noted above.
export const EXPORT_AD_IDS = {
  DONUTS: 'export_donuts_2026',
  MATH_CHALLENGE: 'export_math_challenge_2026',
  MATH_AWARENESS: 'export_math_awareness_2026',
  MATH_SHARE: 'export_math_share_2026',
  MATH_FREE_YEAR: 'export_math_free_year_2026',
  REFERRAL: 'export_referral_2026',
};

export const SIDEBAR_AD_IDS = {
  DONUTS: 'sidebar_donuts_2026',
  PREMIUM_EXPIRING: 'sidebar_premium_expiring_2026',
  PREMIUM_ENDED: 'sidebar_premium_ended_2026',
  PREMIUM_ENDED_INVITE: 'sidebar_premium_ended_invite_2026',
  TRIAL_EXPIRING: 'sidebar_trial_expiring_2026',
  TRIAL_EXPIRING_INVITE: 'sidebar_trial_expiring_invite_2026',
  TRIAL_ENDED: 'sidebar_trial_ended_2026',
  TRIAL_ENDED_INVITE: 'sidebar_trial_ended_invite_2026',
  CHROME_EXTENSION: 'sidebar_chrome_extension_2026',
  CURRICULUM_ANNOUNCEMENT: 'sidebar_curriculum_announcement_2026',
  CURRICULUM_ANNOUNCEMENT_ADMIN: 'sidebar_curriculum_announcement_admin_2026',
  MATH_CHALLENGE: 'sidebar_math_challenge_2026',
  MATH_AWARENESS: 'sidebar_math_awareness_2026',
  MATH_SHARE: 'sidebar_math_share_2026',
  MATH_FREE_YEAR: 'sidebar_math_free_year_2026',
  REFERRAL: 'sidebar_referral_2026',
};

export const nuxKeyFor = (adId) => `in_app_ad_${adId}`;
